import { BASE_API_URL, NOTIFICATION_URLS } from '../constants';
import { AppService, HTTPHeaders } from './app.service';
import { getTeamId } from '../helpers/functions';

const options = AppService.options();

export const notificationService = {
  get_notification_list: async () => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = {
      options: {
        method: 'GET',
      },
    };
    const response = await AppService.makeRequest(
      `${
        BASE_API_URL + NOTIFICATION_URLS.NOTIFICATION_LIST
      }?teamOwnerId=${getTeamId('teamOwnerId')}`,
      {
        ...reqOptions,
        ...headers,
      }
    );
    return response;
  },
  update_notification_status: async (data) => {
    const reqData = {
      teamOwnerId: getTeamId('teamOwnerId'),
      notificationIds: data,
    };
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const response = await AppService.makeRequest(
      BASE_API_URL + NOTIFICATION_URLS.NOTIFICATION_READ,
      {
        ...options,
        ...headers,
        body: JSON.stringify(reqData),
      }
    );
    return response;
  },
  get_email_settings_notification_list: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = {
      options: {
        method: 'GET',
      },
    };
    const response = await AppService.makeRequest(
      `${BASE_API_URL + NOTIFICATION_URLS.SETTINGS}/${data.teamOwnerId}`,
      {
        ...reqOptions,
        ...headers,
      }
    );
    return response;
  },
  add_notification_recipient: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const response = await AppService.makeRequest(
      `${BASE_API_URL + NOTIFICATION_URLS.SETTINGS}/recipients`,
      {
        ...options,
        ...headers,
        body: JSON.stringify(data),
      }
    );
    return response;
  },
  update_notification_recipients: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = {
      method: 'PUT',
    };
    const response = await AppService.makeRequest(
      `${BASE_API_URL + NOTIFICATION_URLS.SETTINGS}/recipients`,
      {
        ...reqOptions,
        ...headers,
        body: JSON.stringify(data),
      }
    );
    return response;
  },
  delete_notification_recipient: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = {
      method: 'DELETE',
    };
    const response = await AppService.makeRequest(
      `${BASE_API_URL}${NOTIFICATION_URLS.SETTINGS}/recipients/${data.teamOwnerId}/${data.userId}`,
      {
        ...reqOptions,
        ...headers,
      }
    );
    return response;
  },
  update_notify_team_admins_only: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const response = await AppService.makeRequest(
      `${BASE_API_URL + NOTIFICATION_URLS.SETTINGS}/notify-team-admins-only`,
      {
        ...options,
        ...headers,
        body: JSON.stringify(data),
      }
    );
    return response;
  },
};
